module.exports = __webpack_public_path__ + "static/calling-in-counseling-2c8f18ea9c9981c59fc30cc0b7380a07.jpg";